import { useState, useEffect } from "react";
import LayoutWeb from "../LayoutWeb/layoutWeb";
import OfficeForm from "./OfficeForm";
import "./Offices.scss";
import { deleteOffice, getAllOffices } from "../../api/offices.api";

const Offices = () => {
  const [offices, setOffices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [currentOffice, setCurrentOffice] = useState(null);

  const fetchOffices = async () => {
    setLoading(true);
    try {
      const data = await getAllOffices();
      setOffices(data);
    } catch (error) {
      console.error("Error fetching offices:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOffices();
  }, []);

  const handleEdit = (office) => {
    setCurrentOffice(office);
    setShowForm(true);
  };

  const handleCreate = () => {
    setCurrentOffice(null);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de que deseas eliminar esta oficina?")) {
      try {
        await deleteOffice(id);
        fetchOffices();
      } catch (error) {
        console.error("Error al eliminar:", error);
      }
    }
  };

  const closeOfficeForm = () => {
    setShowForm(false);
    setCurrentOffice(null);
  };

  const buildMapsUrl = (address) =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      address,
    )}`;

  return (
    <LayoutWeb subTitle="Gestión de Oficinas">
      <div className="OfficesHeader">
        <h1>
          {showForm
            ? currentOffice
              ? "Editando Oficina"
              : "Nueva Oficina"
            : "Oficinas"}
        </h1>
        {!showForm ? (
          <button className="btn-primary" onClick={handleCreate}>
            + Nueva Oficina
          </button>
        ) : (
          <button className="btn-close" onClick={closeOfficeForm}>
            &times;
          </button>
        )}
      </div>

      {showForm ? (
        <OfficeForm
          officeData={currentOffice}
          closeForm={closeOfficeForm}
          refreshData={fetchOffices}
        />
      ) : loading ? (
        <div className="loading-state">Cargando oficinas...</div>
      ) : offices.length === 0 ? (
        <p>No hay oficinas registradas.</p>
      ) : (
        <div className="OfficesGrid">
          {offices.map((office) => (
            <div key={office._id} className="OfficeCard">
              <div className="OfficeCard__image-container">
                <img
                  src={office.image}
                  alt={office.name}
                  className="OfficeCard__img"
                />
              </div>
              <div className="OfficeCard__content">
                <h3>{office.name}</h3>

                <div className="OfficeCard__info">
                  <div className="OfficeCard__info-row">
                    <span className="OfficeCard__label">Dirección</span>
                    <a
                      href={buildMapsUrl(office.address)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="OfficeCard__address-link"
                    >
                      {office.address}
                    </a>
                  </div>

                  <div className="OfficeCard__info-row">
                    <span className="OfficeCard__label">Horario</span>
                    <div
                      className="OfficeCard__schedule"
                      dangerouslySetInnerHTML={{ __html: office.schedule }}
                    />
                  </div>

                  <div className="OfficeCard__info-row">
                    <span className="OfficeCard__label">Teléfono</span>
                    <a
                      href={`tel:${office.phone}`}
                      className="OfficeCard__phone-link"
                    >
                      {office.phone}
                    </a>
                  </div>
                </div>

                <div className="OfficeCard__actions">
                  <button
                    onClick={() => handleEdit(office)}
                    className="btn-edit"
                  >
                    Editar
                  </button>
                  <button
                    onClick={() => handleDelete(office._id)}
                    className="btn-delete"
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </LayoutWeb>
  );
};

export default Offices;
